import { render, staticRenderFns } from "./OwnersList.vue?vue&type=template&id=25b5b6c7&"
import script from "./OwnersList.vue?vue&type=script&lang=js&"
export * from "./OwnersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports